export default "__VITE_ASSET__XyoiulCX__"